<script setup>
import { onMounted } from "vue";
import AOS from "./assets/vendor/aos/aos.js";
import GLightbox from "./assets/vendor/glightbox/js/glightbox.min.js";

onMounted(() => {
  AOS.init({
    duration: 800,
    easing: "ease-in-out",
    once: true,
    mirror: false,
  });

  GLightbox({ selector: ".glightbox" });
});
</script>

<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>
